<template>
    <svg width="93" height="81" viewBox="0 0 93 81" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="65" cy="16" r="65" fill="#FFD600"/>
</svg>

</template>